import { AvField, AvForm } from "availity-reactstrap-validation";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CartService from "../../../services/CartService";
import {
	loadingToggleAction,
	loginAction,
	signupAction,
} from "../../../store/actions/AuthActions";
import logo from "../../../assets/logo.svg";
import login from "../../../assets/login.jpg";
import eye from "../../../assets/eye.svg";
import eyeSlash from "../../../assets/eye-slash.svg";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";

const Login = () => {
	const [formData, setFormData] = useState({
		email: "",
		password: "",
		user_name: "",
		phone: "",
	});
	const [path, setPath] = useState("");
	const [isLogin, setIsLogin] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [forgetPassword, setForgetPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const lang = useSelector((state) => state?.lang?.lang);
	const { t } = useTranslation();
	const cartService = new CartService();
	const user = useSelector((state) => state?.user);
	useEffect(() => {
		if (location?.pathname === "/login") {
			setIsLogin(true);
		} else {
			setIsLogin(false);
		}
		if (!!location?.state) {
			setPath(location?.state?.path);
		}
	}, [location?.pathname]);

	const submit = () => {
		let cartProducts = {
			products: user?.cart?.map((product) => {
				return {
					dynamic_variant: product?.dynamicVariants
						?.filter((res) => res?.amount > 0)
						?.map((res) => {
							return {
								dynamic_variant_id: res?.id,
								amount: res?.amount,
							};
						}),
					amount: product?.amount,
					product_id: product?.id,
				};
			}),
		};
		if (user?.promoCode) cartProducts["promoCode"] = user?.promoCode?.coupon;
		dispatch(loadingToggleAction(true));
		let data = {
			email: formData?.email,
			password: formData?.password,
		};

		if (isLogin) {
			dispatch(
				loginAction(data, navigate, path, setLoading, cartService, cartProducts)
			);
		} else {
			data["phone"] = formData.phone;
			data["username"] = formData.user_name;
			dispatch(
				signupAction(
					data,
					navigate,
					path,
					setLoading,
					cartService,
					cartProducts
				)
			);
		}
	};

	return (
		<div className={`login-wrapper ${lang}`}>
			<div className="login-aside-left position-relative">
				<img src={login} alt="login" className="w-100" />
			</div>
			<div className="login-aside-right d-flex flex-column justify-content-center">
				<div className="row justify-content-center align-items-center">
					<div className="col-xl-9 col-md-11">
						<div className="authincation-content auth-form">
							<div
								className="text-center mt-4"
								style={{ marginBottom: "30px" }}>
								<img src={logo} alt="logo" className="login-logo" />
							</div>
							<div className="text-center" style={{ marginBottom: "20px" }}>
								<h3 className="fs-18" style={{ fontWeight: "600" }}>
									{isLogin ? t("Login") : t("Sign Up")}
								</h3>
							</div>
							<AvForm onValidSubmit={submit} className="login-form">
								<Row>
									{!isLogin && (
										<>
											<Col md={12} className="form-group">
												<label
													style={{
														fontSize: "14px",
														color: "#3d4465",
														fontWeight: "600",
													}}>
													{t("User Name")}
												</label>
												<AvField
													name="user_name"
													type="text"
													value={formData?.user_name}
													errorMessage="Please Enter a Valid Value"
													className="radius-10 h-45"
													validate={{
														required: {
															value: true,
														},
													}}
													placeholder={t("User Name")}
													onChange={(e) =>
														setFormData((prev) => ({
															...prev,
															user_name: e.target.value,
														}))
													}
												/>
											</Col>
											<Col md={12} className="mb-3">
												<label
													style={{
														fontSize: "14px",
														color: "#3d4465",
														fontWeight: "600",
													}}>
													{t("Phone")}
												</label>
												<PhoneInput
													country={"kw"}
													enableSearch={true}
													value={formData?.phone}
													onChange={(e) =>
														setFormData((prev) => ({
															...prev,
															phone: e,
														}))
													}
												/>
											</Col>
										</>
									)}
									<Col md={12} className="form-group">
										<label
											style={{
												fontSize: "14px",
												color: "#3d4465",
												fontWeight: "600",
											}}>
											{t("Email")}
										</label>
										<AvField
											name="email"
											type="email"
											value={formData?.email}
											errorMessage="Please Enter a Valid Value"
											className="radius-10 h-45"
											validate={{
												required: {
													value: true,
												},
											}}
											placeholder={t("Email")}
											onChange={(e) =>
												setFormData((prev) => ({
													...prev,
													email: e.target.value,
												}))
											}
										/>
									</Col>
									<Col md={12} className="form-group position-relative">
										<label
											style={{
												fontSize: "14px",
												color: "#3d4465",
												fontWeight: "600",
											}}>
											{t("Password")}
										</label>
										<AvField
											name="password"
											type={showPassword ? "text" : "password"}
											value={formData?.password}
											className="radius-10 h-45"
											errorMessage="Please enter a valid password"
											validate={{
												required: {
													value: true,
												},
											}}
											placeholder={t("Password")}
											onChange={(e) =>
												setFormData((prev) => ({
													...prev,
													password: e.target.value,
												}))
											}
										/>
										{showPassword ? (
											<img
												src={eyeSlash}
												className="showPassword"
												alt="eyeSlash"
												onClick={() => setShowPassword(false)}
											/>
										) : (
											<img
												src={eye}
												className="showPassword"
												alt="eye"
												onClick={() => setShowPassword(true)}
											/>
										)}
									</Col>
									<Col md={12}>
										<button
											type="submit"
											disabled={loading}
											className="btn w-100 fw-bold btn-primary btn-block mb-3 radius-10 h-45">
											{isLogin ? t("Login") : t("Sign Up")}
										</button>
										<p
											className="dont-have-account"
											onClick={() => navigate(isLogin ? "/sign-up" : "/login")}>
											{isLogin ? t("Don't Have Account") : t("Have Account")}{" "}
											<span>
												{isLogin ? t("Create New Account") : t("Login")}
											</span>
										</p>
									</Col>
								</Row>
								<div className="text-center"></div>
							</AvForm>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
	// return <ForgetPassword setForgetPassword={setForgetPassword} />;
};
export default Login;
